<div
    class="flex-container"
    [style.background-color]="(hasData$ | async) ? ((isInsideThreshold$ | async) ? lightPositiveColor : lightNegativeColor) : lightNoData"
>
    <div class="circle-container">
        <div
            class="circle"
            [style.background-color]="(hasData$ | async) ? ((isInsideThreshold$ | async) ? middlePositiveColor : negativeColor) : noData"
        >
            <img src="data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7" />
            <div class="circle-content">
                <img
                    class="smiley"
                    [src]="
                        (hasData$ | async)
                            ? (isInsideThreshold$ | async)
                                ? 'assets/icons/smiley_happy.svg'
                                : 'assets/icons/smiley_sad.svg'
                            : 'assets/icons/smiley_neutral.svg'
                    "
                />
                <div>
                    {{
                        (hasData$ | async)
                            ? (isInsideThreshold$ | async)
                                ? config.translations.positiveMessage
                                : config.translations.negativeMessage
                            : ('GENERIC.NO_DATA' | translate)
                    }}
                </div>
            </div>
        </div>
    </div>
    <div class="data" [style.color]="(hasData$ | async) ? ((isInsideThreshold$ | async) ? positiveColor : negativeColor) : noData">
        <div class="indicator">
            <div class="picture">
                <svg-icon
                    src="/assets/icons/building.svg"
                    [svgStyle]="{
                        width: 40,
                        fill: (hasData$ | async) ? ((isInsideThreshold$ | async) ? positiveColor : negativeColor) : noData
                    }"
                />
            </div>
            <div class="value-label">
                <div class="big value">{{ sensor$ | async | sensorLastPoint }}</div>
                <div class="label">{{ config.translations.description }}</div>
            </div>
        </div>
        <div class="indicator">
            <div class="picture">
                <svg-icon
                    src="/assets/icons/weather.svg"
                    [svgStyle]="{
                        width: 40,
                        fill: (hasData$ | async) ? ((isInsideThreshold$ | async) ? positiveColor : negativeColor) : noData
                    }"
                />
            </div>
            <div class="value-label">
                <div class="value">
                    {{ (weather$ | async)?.weatherData?.main?.temp | localnumber: 1 : 1 : 1 }}
                    {{ outsideTemperatureUnit | referenceListLabel: 'unit' }}
                </div>
                <div class="label">Température extérieure</div>
            </div>
        </div>
    </div>
</div>
